module.exports = __webpack_public_path__ + "static/media/JennAndClaire-5.11e57c69.png";